import { APIResponse } from "../services/HttpService";
import { ApiDefinition } from "./ApiDefinition";
import { IUserInfo } from "./model/user/IUserInfo";
import { UserDTO } from "./model/user/UserDTO";

class UserDataApiDefinition extends ApiDefinition {
  constructor() {
    super("/users");
  }

  async getDataInfo(usernameOrId: string | number): Promise<APIResponse<IUserInfo>> {
    if (typeof usernameOrId === "number") {
      return this.get(`${usernameOrId}`);
    }
    return this.get(`${usernameOrId}/info`);
  }

  async getCurrentUser(): Promise<APIResponse<UserDTO>> {
    return this.get(`info`);
  }

  async getCompanyUsers(companyRef: string): Promise<APIResponse<UserDTO[]>> {
    return this.get(`by-company`, { params: { companyRef } });
  }
}

export const UserDataApi = new UserDataApiDefinition();
